import React, { lazy, Suspense } from 'react';
import { LoadingSpinner } from '../Loading/LoadingSpinner';

// Lazy load the Logo3D component
const Logo3D = lazy(() => import('./Logo3D'));

interface LazyLogo3DProps {
  logoUrl: string;
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

/**
 * Lazy-loaded version of Logo3D with loading fallback
 */
const LazyLogo3D: React.FC<LazyLogo3DProps> = (props) => {
  return (
    <Suspense 
      fallback={
        <div className="logo-section">
          <div className="logo-3d-container logo-3d-medium">
            <div className="flex items-center justify-center h-full">
              <LoadingSpinner size="large" />
            </div>
          </div>
        </div>
      }
    >
      <Logo3D {...props} />
    </Suspense>
  );
};

export default LazyLogo3D;